import { render, staticRenderFns } from "./ModalNewReservation.vue?vue&type=template&id=b874d84c&"
import script from "./ModalNewReservation.vue?vue&type=script&lang=js&"
export * from "./ModalNewReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports